var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"mr-auto"},[_vm._v(" Profile ")]),_c('b-modal',{attrs:{"id":_vm.id}},[_vm._v("Hello From My Modal!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }